/*
 * Copyright    :Copyright© 2022 AOMEI
 * Abstract     :
 * Date         :2023-04-05 20:09:14
 * Author       :
 * LastEditors  :chenjia
 * LastEditTime :2025-05-15 10:42:59
 * FilePath     :\AV-COM-user-backend\src\lang\index.js
 * RevisionHistory:
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import { currentLang } from "@/utils/util";
// 导入语言包信息
import en from "./locale/en.json";
import zhCN from "./locale/zh-CN.json";
import es from "./locale/es.json";
import de from "./locale/de.json";
import it from "./locale/it.json";
import jp from "./locale/jp.json";
import fr from "./locale/fr.json";
import tw from "./locale/tw.json";
import pt from "./locale/pt.json";
import cn from "./locale/cn.json";

// 注册i18n
Vue.use(VueI18n);

// 语言包根据语言环境分类
const messages = {
    en,
    de,
    it,
    es,
    fr,
    jp,
    tw,
    pt,
    cn,
    "zh-CN": zhCN,
};

// 配置语言
let lang = currentLang();
console.log(123456, lang);
if (process.env.NODE_ENV == "development") {
    lang = lang;
} else {
    if (window.location.host === "www.anyviewer.cn") {
        lang = "cn";
    } else {
        (lang === "zh-CN" || lang === "cn") && (lang = "zh-CN");
    }
}

// classVal = classVal.replace("classVal", `av-${lang}`);
// document.getElementById("app").setAttribute("class", classVal);

// 通过选项创建 VueI18n 实例并导出
export default new VueI18n({
    locale: lang, // 设置当前语言环境，默认中文简体
    fallbackLocale: "en", // 未匹配到语言时的fallback语言
    messages, // 设置语言环境对应信息
});
